// extracted by mini-css-extract-plugin
export default {"underBanner":"DepWith_underBanner__FMHRe","content":"DepWith_content__lKB9y","text":"DepWith_text__hh4fu","image":"DepWith_image__4K0EN"};